module.exports = __webpack_public_path__ + "img/marker--thumbs-up.21ee970.svg";